import { useContext } from 'react';

import { IOnboardingContext, OnboardingCtx } from '~/context/OnboardingContext';

const useOnboarding = (): IOnboardingContext => useContext(OnboardingCtx);

export default useOnboarding;
